import * as React from "react";

import { Phone } from "@mui/icons-material";
import { IconButton } from "@mui/material";

export interface PhoneButtonProps {
  phoneNumber: string;
  extension?: string;
}

const stripFormatting = (phoneNumber: string) => phoneNumber.replace(/\D/g, "");

const formatNumber = (phoneNumber: string) => {
  const digits = stripFormatting(phoneNumber);
  if (digits.length < 4) return digits;
  if (digits.startsWith("1") && digits.length < 5)
    return `+1 (${digits.slice(1)}`;
  if (digits.startsWith("1") && digits.length <= 11) {
    return `+1 (${digits.slice(1, 4)}) ${
      digits.length < 8
        ? digits.slice(4)
        : `${digits.slice(4, 7)}-${digits.slice(7)}`
    }`;
  }
  if (digits.length <= 10) {
    return `(${digits.slice(0, 3)}) ${
      digits.length < 7
        ? digits.slice(3)
        : `${digits.slice(3, 6)}-${digits.slice(6)}`
    }`;
  }
  return digits;
};

export const PhoneButton: React.FC<PhoneButtonProps> = ({
  phoneNumber,
  extension,
}) => {
  const digits = stripFormatting(phoneNumber);
  const telLink = extension ? `tel:${digits},${extension}` : `tel:${digits}`;

  return (
    <div style={{ display: "inline-block" }}>
      <IconButton
        onClick={() => {
          window.location.href = telLink;
        }}
        aria-label="dial phone number"
        size="small"
      >
        <Phone color="secondary" />
      </IconButton>
      <a href={telLink}>
        {formatNumber(phoneNumber)}
        {extension && ` Ext. ${extension}`}
      </a>
    </div>
  );
};
